// Set this to false, or set REACT_APP_USER_LOANS_UI_ENABLED=false, to hide the
// standalone User Loans entry point without changing the existing CRM/profile flow.
const defaultEnabled = true;

export const USER_LOANS_UI_ENABLED =
  process.env.REACT_APP_USER_LOANS_UI_ENABLED === undefined
    ? defaultEnabled
    : process.env.REACT_APP_USER_LOANS_UI_ENABLED === "true";

